/**
 * NotificationToaster — always-on toast orkestrasyonu (N2-03; N4'te sadeleşti)
 *
 * app-shell (authenticated layout) içinde TEK mount edilir → yalnız oturumlu
 * kullanıcıda çalışır, logout ekranlarında değil. Görsel yer kaplamaz: sonner
 * <Toaster> zaten main.tsx'te. Bu bileşen useNotificationToasts ile toast
 * kararını verir (yan etki), ekrana kendisi bir şey basmaz.
 *
 * N4 kararı (kullanıcı, 2026-07-07): "zile uçan pill" animasyonu KALDIRILDI —
 * normal sonner toast animasyonu yeterli, ekstra karmaşıklık istenmedi.
 */
import { useNotificationToasts } from '@/hooks/use-notification-toasts'

export function NotificationToaster() {
  // Toast kararını verir (yan etki hook) — görsel çıktı üretmez.
  useNotificationToasts()
  return null
}
